import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_SCHEMA_WITH_DESCRIPTIONS = gql`
  query GetSchemaWithDescriptions(
    $table_name: String
    $generate_descriptions: Boolean!
    $user_id: Int!
    $user_db_id: Int!
    $db_type: String
  ) {
    getSchemaWithDescriptions(
      table_name: $table_name
      generate_descriptions: $generate_descriptions
      user_id: $user_id
      user_db_id: $user_db_id
      db_type: $db_type
    ) {
      success
      database
      schema_name
      total_tables
      total_columns
      tables {
        table_name
        table_schema
        table_type
        row_count
        comment
        columns {
          column_name
          data_type
          is_nullable
          ordinal_position
          comment
          description
        }
      }
      jobId
      status
      message
    }
  }
`;

export const useGetSchemaWithDescriptions = () => {
  const [getSchema, { data, loading, error }] = useLazyQuery(GET_SCHEMA_WITH_DESCRIPTIONS);

  const generateDescriptions = useCallback(async ({ tableName, userId, userDbId, dbType = "postgres" }) => {
    try {
      const result = await getSchema({
        variables: {
          table_name: tableName,
          generate_descriptions: true,
          user_id: userId,
          user_db_id: userDbId,
          db_type: "postgres",
        },
      });

      if (result.data?.getSchemaWithDescriptions?.success) {
        const response = result.data.getSchemaWithDescriptions;
        
        return {
          success: true,
          data: response,
          jobId: response.jobId,
          message: response.message,
          error: null,
        };
      } else {
        return {
          success: false,
          data: null,
          jobId: null,
          message: null,
          error: "Failed to generate descriptions",
        };
      }
    } catch (err) {
      return {
        success: false,
        data: null,
        jobId: null,
        message: null,
        error: err.message || "Failed to generate descriptions",
      };
    }
  }, [getSchema]);

  return {
    generateDescriptions,
    loading,
    error,
    data,
  };
};
